import React from 'react';
import { FaSearch, FaUser, FaBuilding, FaUserPlus } from 'react-icons/fa';

const SupplierSection = ({
  formData,
  handleInputChange,
  customerSearch,
  setCustomerSearch,
  customerResults,
  showCustomerResults,
  setShowCustomerResults,
  selectedCustomer,
  clearCustomer,
  handleSelectCustomer,
  onAddNewCustomer,
  // Opcjonalne: odpina fakture od karty, zostawiajac snapshot tekstowy.
  // Gdy strona go nie poda, zerujemy samo pole customer_id.
  onOdepnijKontrahenta = null,
  cardStyle,
  cardHeaderStyle,
  inputStyle,
  labelStyle,
  btnStyle
}) => {
  // Zrodlem prawdy o powiazaniu jest customer_id w formularzu (to ono jedzie
  // do backendu jako kontrahent_id), a NIE obecnosc obiektu selectedCustomer.
  const kontrahentId = formData?.customer_id || null;
  const powiazany = !!kontrahentId;

  const nazwaKontrahenta =
    selectedCustomer?.nazwa_firmy ||
    selectedCustomer?.name ||
    `${selectedCustomer?.imie || ''} ${selectedCustomer?.nazwisko || ''}`.trim() ||
    formData?.nazwa_dostawcy ||
    'karta bez nazwy';
  const numerKontrahenta = selectedCustomer?.numer_klienta || '';

  const odepnij = () => {
    if (onOdepnijKontrahenta) {
      onOdepnijKontrahenta();
      return;
    }
    handleInputChange('customer_id', null);
  };

  const badgeRoli = (customer) => {
    if (customer?.jest_dostawca === 1 || customer?.jest_dostawca === true) {
      return (
        <span style={{
          display: 'inline-block', marginLeft: '6px', padding: '1px 6px', borderRadius: '3px',
          backgroundColor: 'var(--purple-light)', color: 'var(--purple)',
          fontSize: '10px', fontWeight: '600'
        }}>Dostawca</span>
      );
    }
    return null;
  };

  return (
    <div style={cardStyle}>
      <div style={cardHeaderStyle}>
        <FaBuilding /> Nabywca / Dostawca
        <button
          onClick={onAddNewCustomer}
          style={{
            ...btnStyle,
            marginLeft: 'auto',
            border: '1px solid var(--success)', color: 'var(--success)' ,
            padding: '4px 10px',
            fontSize: '11px'
          }}
        >
          <FaUserPlus /> Nowy
        </button>
      </div>
      <div style={{ padding: '0.75rem' }}>
        {/* Customer search */}
        <div style={{ position: 'relative', marginBottom: '0.5rem' }}>
          <label style={labelStyle}>Wyszukaj klienta z bazy</label>
          <div style={{ position: 'relative' }}>
            <FaSearch style={{
              position: 'absolute', left: '8px', top: '50%',
              transform: 'translateY(-50%)', color: 'var(--text-muted)', fontSize: '11px'
            }} />
            <input
              type="text"
              value={customerSearch}
              onChange={(e) => setCustomerSearch(e.target.value)}
              onFocus={() => customerSearch.length >= 2 && setShowCustomerResults(true)}
              style={{ ...inputStyle, paddingLeft: '28px' }}
              placeholder="Wpisz nazwe, NIP lub telefon..."
            />
            {selectedCustomer && (
              <button
                onClick={clearCustomer}
                style={{
                  position: 'absolute', right: '8px', top: '50%',
                  transform: 'translateY(-50%)', background: 'none',
                   cursor: 'pointer', color: 'var(--danger)', fontSize: '12px'
                }}
              >
                X
              </button>
            )}
          </div>

          {showCustomerResults && customerResults.length > 0 && (
            <div style={{
              position: 'absolute', top: '100%', left: 0, right: 0,
              backgroundColor: 'var(--card-bg)', border: '1px solid var(--border)',
              borderRadius: '4px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              zIndex: 100, maxHeight: '200px', overflowY: 'auto'
            }}>
              {customerResults.map(customer => (
                <div
                  key={customer.id}
                  onClick={() => handleSelectCustomer(customer)}
                  style={{
                    padding: '0.5rem 0.75rem', cursor: 'pointer',
                    borderBottom: '1px solid var(--bg)', fontSize: '11px'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'var(--bg)'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'var(--card-bg)'}
                >
                  <div style={{ fontWeight: '600' }}>
                    {customer.nazwa_firmy || customer.name || `${customer.imie || ''} ${customer.nazwisko || ''}`.trim() || 'Bez nazwy'}
                    {badgeRoli(customer)}
                  </div>
                  <div style={{ color: 'var(--text-muted)', fontSize: '10px' }}>
                    {customer.nip && `NIP: ${customer.nip} | `}
                    {(customer.telefon || customer.phone) && `Tel: ${customer.telefon || customer.phone}`}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Status powiazania z kartoteka. Bez tej linijki uzytkownik nie ma jak
            odroznic faktury z ID karty od faktury z samym wolnym tekstem. */}
        <div style={{
          padding: '0.5rem',
          backgroundColor: powiazany ? 'var(--success-light)' : 'var(--warning-light)',
          border: `1px solid ${powiazany ? 'var(--success)' : 'var(--warning)'}`,
          borderRadius: '4px', marginBottom: '0.5rem',
          display: 'flex', alignItems: 'center', gap: '8px'
        }}>
          {powiazany ? (
            <>
              <div style={{ fontSize: '11px', color: 'var(--success)', flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: '600' }}>
                  <FaUser style={{ marginRight: '4px' }} />
                  Powi{'ą'}zany z kartotek{'ą'}: {nazwaKontrahenta}
                  {numerKontrahenta ? ` (nr ${numerKontrahenta})` : ''}
                </div>
                {selectedCustomer?.nip && (
                  <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>NIP: {selectedCustomer.nip}</div>
                )}
              </div>
              <button
                type="button"
                onClick={odepnij}
                title="Usun powiazanie z kartoteka (dane tekstowe na fakturze zostaja)"
                style={{
                  padding: '4px 10px', fontSize: '11px', cursor: 'pointer',
                  backgroundColor: 'var(--card-bg)', color: 'var(--danger)',
                  border: '1px solid var(--danger)', borderRadius: '4px'
                }}
              >
                Odepnij
              </button>
            </>
          ) : (
            <div style={{ fontSize: '11px', color: 'var(--warning)', fontWeight: '600' }}>
              Brak powi{'ą'}zania z kartotek{'ą'} {'—'} faktura trafi do listy do sparowania
            </div>
          )}
        </div>

        {/* Manual supplier fields */}
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '0.5rem', marginBottom: '0.5rem' }}>
          <div>
            <label style={labelStyle}>Nazwa</label>
            <input type="text" value={formData.nazwa_dostawcy}
              onChange={(e) => handleInputChange('nazwa_dostawcy', e.target.value)} style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>NIP</label>
            <input type="text" value={formData.nip_dostawcy}
              onChange={(e) => handleInputChange('nip_dostawcy', e.target.value)} style={inputStyle} />
          </div>
        </div>
        <div style={{ marginBottom: '0.5rem' }}>
          <label style={labelStyle}>Adres</label>
          <input type="text" value={formData.adres_dostawcy}
            onChange={(e) => handleInputChange('adres_dostawcy', e.target.value)} style={inputStyle} />
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem' }}>
          <div>
            <label style={labelStyle}>Telefon</label>
            <input type="text" value={formData.telefon_dostawcy}
              onChange={(e) => handleInputChange('telefon_dostawcy', e.target.value)} style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Email</label>
            <input type="email" value={formData.email_dostawcy}
              onChange={(e) => handleInputChange('email_dostawcy', e.target.value)} style={inputStyle} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupplierSection;
